import Swiper from 'swiper/bundle'

export default class ImgLink {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
    this.initSwiper()
    this.initDesktop()
  }

  initSwiper() {
    const swiperEl = this.el.querySelector('.img-link--slider')
    if (!swiperEl) return
    new Swiper(swiperEl, {
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      grabCursor: true,
    })
  }

  initDesktop() {
    this.el.querySelector('#img-0')?.classList.add('is-active')
    this.el.querySelector('#text-0')?.classList.add('is-active')
    this.el.querySelector('#title-0')?.classList.add('is-active')

    this.el.querySelectorAll('.img-link--title-item').forEach(title => {
      title.addEventListener('click', () => {
        this.el.querySelectorAll('.img-link--title-item').forEach(t => t.classList.remove('is-active'))
        this.el.querySelectorAll('.img-link--wrapper-content, .img-link--img').forEach(el => el.classList.remove('is-active'))

        const index = title.id.replace('title-', '')
        this.el.querySelector(`#text-${index}`)?.classList.add('is-active')
        this.el.querySelector(`#img-${index}`)?.classList.add('is-active')
        title.classList.add('is-active')
      })
    })
  }
}
